import SpecLink from "components/Pages/TierLists/SpecLink";
import React, { useMemo, useState } from "react";

const WowTooltip = (props) => {
  const { type, id, def, name, rank, children, className } = props;
  const [isLink, setIsLink] = useState(false);
  const correctedType = useMemo(() => {
    if (type === "talent") {
      return "spell";
    }
    return type;
  }, [type]);

  const formatNameForTalentTooltip = (talentName) => {
    return talentName ? talentName.toLowerCase().replace(/\s+/g, "-") : talentName;
  };

  const link =
    def && name && rank
      ? `http://www.wowhead.com/${correctedType}=${id}/${formatNameForTalentTooltip(name)}?def=${def}&rank=${rank}`
      : `http://www.wowhead.com/${correctedType}=${id}`;
  const propList = {
    className,
    "data-tooltip-id": id,
    "data-tooltip-name": formatNameForTalentTooltip(name),
    "data-tooltip-rank": rank,
    "data-tooltip-def": def,
  };

  if (isLink && type === "spell") {
    return (
      <a {...propList} href={link} rel="nofollow" onClick={(e) => e.preventDefault()} style={{ cursor: "default" }}>
        {children}
      </a>
    );
  }

  if (isLink) {
    return (
      <a {...propList} href={link} target="_blank" rel="nofollow" style={{ cursor: "pointer" }}>
        {children}
      </a>
    );
  }

  return (
    <div {...propList} onMouseOver={() => setIsLink(true)}>
      {children}
    </div>
  );
};

export default WowTooltip;
